import { BreadCrumb } from "primereact/breadcrumb";
import { Chart } from "primereact/chart";
import { useEffect, useState } from "react";
import AdmissionRequestService from "../../../api/AdmissionRequestService";
import TrainingService from "../../../api/TrainingService";

export default function Statistic() {
  const items = [{ label: "Statistiques" }];
  const statistic = { icon: "pi pi-chart-bar", url: "/statistic" };
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [loading, setLoading] = useState(true);
  const [admissionRequests, setAdmissionRequests] = useState([]);
  const colors = [
    "--blue-500",
    "--blue-300",
    "--green-500",
    "--green-300",
    "--yellow-500",
    "--yellow-300",
    "--cyan-500",
    "--cyan-300",
    "--pink-500",
    "--pink-300",
    "--indigo-500",
    "--indigo-300",
    "--teal-500",
    "--teal-300",
    "--orange-500",
    "--orange-300",
    "--bluegray-500",
    "--bluegray-300",
    "--purple-500",
    "--purple-300",
    "--red-500",
    "--red-300",
    "--primary-500",
    "--primary-300",
  ];
  const getRandomColor = () => {
    if (colors.length === 0) {
      return null; // Si toutes les couleurs ont été utilisées
    }

    const randomIndex = Math.floor(Math.random() * colors.length);
    const randomColor = colors[randomIndex];
    colors.splice(randomIndex, 1); // Retirer la couleur sélectionnée du tableau
    return randomColor;
  };
  const getCandidatesOfMonth = (admissionRequests, year, month) => {
    // Formater la date du début du mois
    const startOfMonth = `${year}-${month.toString().padStart(2, "0")}-01`;

    // Calculer la date de fin du mois
    const endOfMonth = new Date(year, month, 0); // Le 0ème jour du mois précédent est la dernière journée du mois actuel
    const endOfMonthFormatted = `${year}-${month
      .toString()
      .padStart(2, "0")}-${endOfMonth.getDate()}`;

    // Filtrer les candidatures pour ceux qui sont dans le mois donné
    const candidatesOfMonth = admissionRequests.filter((adRequest) => {
      // Extraire le mois et l'année du created_at
      const adRequestDate = new Date(adRequest.created_at);
      const adRequestYear = adRequestDate.getFullYear();
      const adRequestMonth = adRequestDate.getMonth() + 1; // Les mois sont indexés à partir de 0

      // Comparer avec le mois et l'année donnés
      return adRequestYear === year && adRequestMonth === month;
    });

    return candidatesOfMonth.length;
  };
  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    /* const data = {
      labels: [
        "Janvier",
        "Fevrier",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Decembre",
      ],
      datasets: [
        {
          label: "My First dataset",
          backgroundColor: documentStyle.getPropertyValue(getRandomColor()),
          borderColor: documentStyle.getPropertyValue(getRandomColor()),
          data: [65, 59, 80, 81, 56, 55, 40],
        },
        {
          label: "My Second dataset",
          backgroundColor: documentStyle.getPropertyValue("--pink-500"),
          borderColor: documentStyle.getPropertyValue("--pink-500"),
          data: [28, 48, 40, 19, 86, 27, 90],
        },
      ],
    }; */
    TrainingService.getAll()
      .then((res) => {
        // setTrainings(res.data.trainingPrograms);
        AdmissionRequestService.getAll()
          .then((result) => {
            setAdmissionRequests(result.data.admissionRequests);
            let datasets = [];
            const labels = [
              "Janvier",
              "Fevrier",
              "Mars",
              "Avril",
              "Mai",
              "Juin",
              "Juillet",
              "Août",
              "Septembre",
              "Octobre",
              "Novembre",
              "Decembre",
            ];
            res.data.trainingPrograms.forEach((train) => {
              const trainAdmissions = result.data.admissionRequests.filter(
                (admissionRequest) =>
                  admissionRequest.branche_training_program?.training_program
                    ?.id == train.id
              );
              let dataset = {
                label: train.name,
                backgroundColor: documentStyle.getPropertyValue(
                  getRandomColor()
                ),
                borderColor: documentStyle.getPropertyValue(getRandomColor()),
                data: labels.map((lab, index) =>
                  getCandidatesOfMonth(
                    trainAdmissions,
                    new Date().getFullYear(),
                    index + 1
                  )
                ),
              };
              datasets.push(dataset);
            });
            const data = {
              labels: labels,
              datasets: datasets,
            };
            setChartData(data);
            setLoading(false);
          })
          .catch((err) => console.log("err", err));
      })
      .catch((err) => {});
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            fontColor: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
    setChartOptions(options);
  }, []);
  return (
    <div className="p-4 w-full border-round">
      <div>
        <BreadCrumb model={items} home={statistic} />
      </div>
      <div className="bg-white my-3 py-4  px-4 card">
        <div>
          <h5 className="text-center mb-4" style={{ textDecoration: "underline" }} >Nombre total de candidature par parcours/mois</h5>
        </div>
        <Chart type="bar" data={chartData} options={chartOptions} style={{ minHeight:"70vh" }} />
      </div>
    </div>
  );
}
